import React from "react";

export default function Interest() {
    return (
        <div className="interest">
        <h3 className="interest--title">Interests</h3>
        <p className="interest--paragraph">
        I relish competitive sports like football and cricket, enjoy cultural entertainment through movies and music, and embrace outdoor adventures through activities like skating, hiking. These activities mirror my energetic lifestyle and zest for new experiences.
        </p>
        </div>
    );
}